import { Container, Typography, styled } from '@mui/material'
import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import Filter from '../../components/Filter'
import AdminHeader from '../../components/Headers/AdminHeader'
import LoadingScreen from '../../components/LoadingScreen'
import AdminDashboardTable from '../../components/Table'
import { USER_TYPE } from '../../constants'
import { useGetAccountsDB } from '../../hooks/Admin/useAdminDashboard'
import { themes } from '../../theme'

type TYPE_PROPS = {
  title: string
  queryResult: any
  search: string
  setSearch: (value: string) => void
  filteredData: {
    totalPage: number
    showCurrentPage: number
    currentData: any[]
  }
  isClientRefusal: boolean | undefined
}

const AccountDashBoard = () => {
  const { account } = useParams()
  const type: TYPE_PROPS = useGetAccountsDB(account)

  const { search, setSearch, filteredData, isClientRefusal } = type
  if (!type) {
    return <Navigate to="/dashboard" replace />
  }
  const { isLoading, isFetching } = type.queryResult

  const items = filteredData?.currentData ?? []

  const onLoad = (search: string, status: string) => {
    setSearch(search)
  }

  return (
    <AdminHeader>
      <Container
        maxWidth={false}
        sx={{ backgroundColor: themes.light.background }}
      >
        {isLoading ? (
          <LoadingScreen />
        ) : (
          <React.Fragment>
            <Container
              disableGutters
              maxWidth="xl"
              component="main"
              sx={{ pl: 5, pr: 5, pb: 2, pt: 2 }}
            >
              <Title variant="h3" color="inherit" noWrap fontWeight="bold">
                {type.title}
              </Title>
            </Container>
            <Container
              disableGutters
              maxWidth="xl"
              component="main"
              sx={{ pl: 5, pr: 5, pb: 2 }}
            >
              <Filter
                isFetching={isFetching}
                onLoad={onLoad}
                search={search}
                searchPlaceholder={
                  account === USER_TYPE.SUPER_ADMIN.TYPE
                    ? 'Search Super Admins'
                    : 'Search Client'
                }
                noStatusFilter
                admin
              />
            </Container>
            {/* Table Section */}
            <Container
              disableGutters
              maxWidth="xl"
              component="main"
              sx={{ pb: 20, pl: 5, pr: 5 }}
            >
              <AdminDashboardTable
                data={items}
                userType={
                  isClientRefusal
                    ? USER_TYPE.CLIENT_REFUSED.TYPE
                    : USER_TYPE.ADMIN.TYPE
                }
                newPagination={filteredData}
                hidePagination
              />
            </Container>
            {/* Table Section */}
          </React.Fragment>
        )}
      </Container>
    </AdminHeader>
  )
}

export default AccountDashBoard

const Title = styled(Typography)({
  color: themes.light.primary,
  flexGrow: 1,
})
